import { render } from "./tree.vue?vue&type=template&id=a3b763a2&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=a3b763a2&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b763a2"]])

export default __exports__